import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import source from './modules/source'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    actions,
    getters,

    modules: {
        source
    },

    strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js